import React, { useContext, useState } from "react";
import { Modal, TitleBar } from "@shopify/app-bridge-react";
import { Card, Page, TextContainer } from "@shopify/polaris";
import { ExternalMinor } from "@shopify/polaris-icons";
import { Formik } from "formik";

import { settingsValidationSchema } from "api/settingsValidation";
import { shopActions } from "store/shopStore";
import { storeConnect } from "appStore";
import makeRequestProps from "store/makeRequestProps";
import { ensureDefaults } from "types/constants/settings";
import AppearanceForm from "./AppearanceForm";

import { NavigationContext } from "contexts/Navigation";
import { FlagsContext } from "contexts/Flags";
import { ShopProvider } from "contexts/Shop";

function AppearanceRoute(props) {
  const [cancelAlertOpen, setCancelAlertOpen] = useState(false);
  const navigation = useContext(NavigationContext);
  const flags = useContext(FlagsContext);

  const handleSubmit = values => {
    props.putCustomizations(values, () => navigation.goTo("/"));
  };

  const handleCancel = dirty => {
    dirty ? setCancelAlertOpen(true) : navigation.goTo("/");
  };

  const {
    shopRequest: {
      shop: { app_settings: settings, customizations }
    }
  } = props;

  const linkUrl =
    "https://documentation.orbitapps.com/en/articles/11380242-changing-your-appearance-settings";

  return (
    <ShopProvider value={props.shopRequest.shop}>
      <Page
        title="Appearance"
        subtitle="Customize the style and positioning of your offers."
        secondaryActions={[
          {
            content: "Learn more",
            external: true,
            icon: ExternalMinor,
            url: linkUrl
          }
        ]}
      >
        <Formik
          onSubmit={handleSubmit}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={ensureDefaults(settings, customizations)}
          validationSchema={() =>
            settingsValidationSchema({
              releaseEnableBadgesPerOffer: flags.releaseEnableBadgesPerOffer
            })
          }
        >
          {form => (
            <>
              <TitleBar title="Appearance">
                <button variant="primary" onClick={form.submitForm}>
                  Save
                </button>
                <button onClick={() => handleCancel(form.dirty)}>Cancel</button>
              </TitleBar>

              <AppearanceForm
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
                setEvent={props.setEvent}
              />

              <Modal open={cancelAlertOpen}>
                <TitleBar title="You have unsaved changes">
                  <button
                    variant="primary"
                    tone="critical"
                    onClick={() => {
                      setCancelAlertOpen(false);
                      navigation.goTo("/");
                    }}
                  >
                    Leave page
                  </button>
                  <button onClick={() => setCancelAlertOpen(false)}>
                    Cancel
                  </button>
                </TitleBar>
                <Card>
                  <Card.Section>
                    <TextContainer>
                      <p>
                        If you leave this page, all your unsaved changes will be
                        lost. Are you sure you want to discard these changes and
                        leave this page?
                      </p>
                    </TextContainer>
                  </Card.Section>
                </Card>
              </Modal>
            </>
          )}
        </Formik>
      </Page>
    </ShopProvider>
  );
}

const mapStateToProps = state => {
  return {
    shopRequest: makeRequestProps(state, "shop")
  };
};

export default storeConnect(AppearanceRoute, mapStateToProps, shopActions);
